import React from "react";
import DataMetricsSection from "./components/DataMetricsSection";
import SectorManagementSection from "./components/SectorManagementSection";
import TranslationModal from "./components/TranslationModal";
import DataQualitySection from "./components/DataQualitySection";
import MasterDataSection from "./components/MasterDataSection";

export default function AdminDataTab(props) {
  const {
    activeTab,
    tx,
    setDataRange,
    dataRange,
    fetchDataMetrics,
    buttonStyle,
    dataLoading,
    dataError,
    dataMetrics,
    numberFmt,
    locale,
    chartColors,
    insightsFallbackUsed,
    insightsFallbackReason,
    insightsWindowDays,
    insightsLoading,
    insightsError,
    materialInsights,
    selectedMaterial,
    setSelectedMaterial,
    fetchMaterialDetail,
    materialDetail,
    materialPipelineStatus,
    materialPipelineStatusLoading,
    materialPipelineStatusError,
    fetchMaterialPipelineStatus,
    sectorsError,
    fetchSectors,
    sectorsLoading,
    sectors,
    selectedSectorId,
    loadSectorDetail,
    translationButton,
    createSector,
    sectorForm,
    setSectorForm,
    fieldStyle,
    labelStyle,
    inputStyle,
    selectStyle,
    sectorDetail,
    sectorDetailLoading,
    deleteSector,
    sectorEditForm,
    setSectorEditForm,
    updateSector,
    removeMaterialFromSector,
    materialSearch,
    searchMaterials,
    materialAddTarget,
    setMaterialAddTarget,
    materialSearchLoading,
    materialSearchError,
    materialSearchResults,
    addMaterialToSector,
    addMaterialToList,
    onListDragEnd,
    listDrafts,
    setListDrafts,
    saveListDraft,
    deleteList,
    removeMaterialFromList,
    listForm,
    setListForm,
    createList,
    translationModalOpen,
    setTranslationModalOpen,
    translationSourceText,
    translationLoading,
    translationInputs,
    setTranslationInputs,
    translationError,
    translationSaving,
    saveTranslationModal,
  } = props;

  if (activeTab !== "data") return null;

  return (
    <>
      <div className="row g-3">
        <DataMetricsSection
          tx={tx}
          setDataRange={setDataRange}
          dataRange={dataRange}
          fetchDataMetrics={fetchDataMetrics}
          buttonStyle={buttonStyle}
          dataLoading={dataLoading}
          dataError={dataError}
          dataMetrics={dataMetrics}
          numberFmt={numberFmt}
          locale={locale}
          chartColors={chartColors}
          insightsFallbackUsed={insightsFallbackUsed}
          insightsFallbackReason={insightsFallbackReason}
          insightsWindowDays={insightsWindowDays}
          insightsLoading={insightsLoading}
          insightsError={insightsError}
          materialInsights={materialInsights}
          selectedMaterial={selectedMaterial}
          setSelectedMaterial={setSelectedMaterial}
          fetchMaterialDetail={fetchMaterialDetail}
          materialDetail={materialDetail}
          materialPipelineStatus={materialPipelineStatus}
          materialPipelineStatusLoading={materialPipelineStatusLoading}
          materialPipelineStatusError={materialPipelineStatusError}
          fetchMaterialPipelineStatus={fetchMaterialPipelineStatus}
        />

        <SectorManagementSection
          tx={tx}
          sectorsError={sectorsError}
          fetchSectors={fetchSectors}
          buttonStyle={buttonStyle}
          sectorsLoading={sectorsLoading}
          sectors={sectors}
          selectedSectorId={selectedSectorId}
          loadSectorDetail={loadSectorDetail}
          translationButton={translationButton}
          createSector={createSector}
          sectorForm={sectorForm}
          setSectorForm={setSectorForm}
          fieldStyle={fieldStyle}
          labelStyle={labelStyle}
          inputStyle={inputStyle}
          sectorDetail={sectorDetail}
          sectorDetailLoading={sectorDetailLoading}
          deleteSector={deleteSector}
          sectorEditForm={sectorEditForm}
          setSectorEditForm={setSectorEditForm}
          updateSector={updateSector}
          removeMaterialFromSector={removeMaterialFromSector}
          materialSearch={materialSearch}
          searchMaterials={searchMaterials}
          materialAddTarget={materialAddTarget}
          setMaterialAddTarget={setMaterialAddTarget}
          selectStyle={selectStyle}
          materialSearchLoading={materialSearchLoading}
          materialSearchError={materialSearchError}
          materialSearchResults={materialSearchResults}
          addMaterialToSector={addMaterialToSector}
          addMaterialToList={addMaterialToList}
          onListDragEnd={onListDragEnd}
          listDrafts={listDrafts}
          setListDrafts={setListDrafts}
          saveListDraft={saveListDraft}
          deleteList={deleteList}
          removeMaterialFromList={removeMaterialFromList}
          listForm={listForm}
          setListForm={setListForm}
          createList={createList}
        />

        <DataQualitySection tx={tx} />

        <MasterDataSection />
      </div>

      <TranslationModal
        tx={tx}
        translationModalOpen={translationModalOpen}
        setTranslationModalOpen={setTranslationModalOpen}
        buttonStyle={buttonStyle}
        fieldStyle={fieldStyle}
        labelStyle={labelStyle}
        inputStyle={inputStyle}
        translationSourceText={translationSourceText}
        translationLoading={translationLoading}
        translationInputs={translationInputs}
        setTranslationInputs={setTranslationInputs}
        translationError={translationError}
        translationSaving={translationSaving}
        saveTranslationModal={saveTranslationModal}
      />
    </>
  );
}
